import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { FilterProvider } from "@/context/FilterContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import DashboardLayout from "@/components/layout/DashboardLayout";
import Overview from "@/pages/Overview";
import EventExplorer from "@/pages/EventExplorer";
import Settings from "@/pages/Settings";
import Reports from "@/pages/Reports";
import Kiosk from "@/pages/Kiosk";
import Reliability from "@/pages/Reliability";
import Availability from "@/pages/Availability";
import Maintainability from "@/pages/Maintainability";
import Safety from "@/pages/Safety";
import ParetoPage from "@/pages/ParetoPage";
import TrendPage from "@/pages/TrendPage";
import FailurePage from "@/pages/FailurePage";
import SubsystemPage from "@/pages/SubsystemPage";
import RollingstockFailure from "@/pages/RollingstockFailure";
import SPM from "@/pages/SPM";
import PowerTSS from "@/pages/PowerTSS";
import PowerRSS from "@/pages/PowerRSS";
import TitleManager from "@/components/TitleManager";

function ProtectedRoute() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        <div className="animate-pulse">Loading TRAMS…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return (
    <FilterProvider>
      <DashboardLayout>
        <Outlet />
      </DashboardLayout>
    </FilterProvider>
  );
}

function RawProtectedRoute() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Outlet />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <TitleManager />
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<RawProtectedRoute />}>
            <Route path="/kiosk" element={<Kiosk />} />
          </Route>
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Overview />} />
            <Route path="/reliability" element={<Reliability />} />
            <Route path="/availability" element={<Availability />} />
            <Route path="/maintainability" element={<Maintainability />} />
            <Route path="/safety" element={<Safety />} />
            <Route path="/pareto" element={<ParetoPage />} />
            <Route path="/trend" element={<TrendPage />} />
            <Route path="/failure" element={<FailurePage />} />
            <Route path="/subsystem" element={<SubsystemPage />} />
            <Route path="/rollingstock" element={<RollingstockFailure />} />
            <Route path="/events" element={<EventExplorer />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/spm" element={<SPM />} />
            <Route path="/power/tss" element={<PowerTSS />} />
            <Route path="/power/rss" element={<PowerRSS />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
